module.exports = __webpack_public_path__ + "static/media/add-button-bg.89743e1c.png";